import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DevModeService } from 'src/app/_services/dev-mode.service';
import {
  ConsentState,
  DiagnosticsConsentService,
} from 'src/app/_services/diagnostics-consent.service';
import { DiagnosticsConsentModalService } from 'src/app/_services/diagnostics-consent-modal.service';
import { LocalStorageService } from 'src/app/_services/localStorage.service';
import { LegalsModalComponent } from '../modals/legals-modal/legals-modal.component';
import { ConfidentialModalComponent } from '../modals/confidential-modal/confidential-modal.component';
import { CguClientModalComponent } from '../modals/cgu-client-modal/cgu-client-modal.component';
import { LogViewerModalComponent } from '../modals/log-viewer-modal/log-viewer-modal.component';

@Component({
  selector: 'app-configuration-profile',
  templateUrl: './configuration-profile.page.html',
  styleUrls: ['./configuration-profile.page.scss'],
  standalone: false,
})
export class ConfigurationProfilePage implements OnInit, OnDestroy {
  role: any;
  user: any;
  langue = localStorage.getItem('lang');
  devModeEnabled = false;
  diagnosticsConsent: ConsentState = { granted: false, version: null, grantedAt: null };
  private destroy$ = new Subject<void>();
  constructor(
    private navController: NavController,
    private localStorageServices: LocalStorageService,
    private translate: TranslateService,
    private modalController: ModalController,
    private devModeService: DevModeService,
    private diagnosticsConsentService: DiagnosticsConsentService,
    private diagnosticsConsentModal: DiagnosticsConsentModalService,
  ) {
    this.role = this.localStorageServices.getUserRole();
    this.user = this.localStorageServices.getUserData();

  }
  ngOnInit() {
    this.devModeService.enabled$
      .pipe(takeUntil(this.destroy$))
      .subscribe((enabled) => (this.devModeEnabled = enabled));
    this.diagnosticsConsentService.consentChanges$
      .pipe(takeUntil(this.destroy$))
      .subscribe((c) => (this.diagnosticsConsent = c));
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** Toggle handler bound to the ion-toggle in the template. */
  async onDiagnosticsToggle(ev: any) {
    const checked = !!ev?.detail?.checked;
    if (checked === this.diagnosticsConsent.granted) {
      return;
    }
    if (!checked) {
      this.diagnosticsConsentService.revoke();
      return;
    }
    const accepted = await this.diagnosticsConsentModal.present({
      variant: 'settings',
    });
    if (accepted) {
      this.diagnosticsConsentService.grant();
      return;
    }
    // Revert the toggle visually since consent was not granted.
    this.diagnosticsConsent = { ...this.diagnosticsConsent };
  }
  goTo(path: string) {
    let baseUrl = ''
    switch (this.role) {
      case 'client':
        baseUrl = 'particulier'
        break;
      case 'prestataire':
        baseUrl = 'prestataire'
        break;
    }
    this.navController.navigateForward(['/' + baseUrl + '/' + path])
  }
  changelang(event: any) {
    const lang = event.target.value;
    let i18n = require(`src/assets/i18n/${lang}.json`);
    this.translate.setTranslation(lang, i18n, true);
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

  async openLegalsModal() {
    const modal = await this.modalController.create({
      component: LegalsModalComponent,
      cssClass: 'legals-modal',
      canDismiss: true,
      showBackdrop: true,
      backdropDismiss: true
    });
    return await modal.present();
  }

  async openConfidentialModal() {
    const modal = await this.modalController.create({
      component: ConfidentialModalComponent,
      cssClass: 'confidential-modal',
      canDismiss: true,
      showBackdrop: true,
      backdropDismiss: true
    });
    return await modal.present();
  }

  async openCguModal() {
    const modal = await this.modalController.create({
      component: CguClientModalComponent,
      cssClass: 'cgu-client-modal',
      canDismiss: true,
      showBackdrop: true,
      backdropDismiss: true
    });
    return await modal.present();
  }

  /** Smooth-scroll to the "Aide au support" section when the user taps the
   *  active-note shown at the top of the page. */
  scrollToDiagSection(): void {
    const el = document.getElementById('diag-section-anchor');
    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  async openLogViewer() {
    const modal = await this.modalController.create({
      component: LogViewerModalComponent,
      cssClass: 'log-viewer-modal',
      canDismiss: true,
      showBackdrop: true,
      backdropDismiss: false,
    });
    return await modal.present();
  }

  disableDevMode() {
    this.devModeService.disable();
  }
}
